import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLayoutSidebarInactive = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	width: 24,
	height: 24,
	strokeWidth: 1.5,
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 4v1" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 9v1" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 14v1" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 19v1" })
	]
});
const ForwardRef = forwardRef(SvgLayoutSidebarInactive);
export default ForwardRef;
